import React, {useState} from 'react';
import {useHistory} from 'react-router-dom';

import Widget from '../Widget';
import NoAnswersYet from './NoAnswersYet';
import TextWidget from './TextWidget';
import PhotoGalleryWidget from './PhotoGalleryWidget';
import BooleanWidget from './BooleanWidget';
import QuestionOptionsWidget from './QuestionOptionsWidget';
import * as flags from '../../lib/flags';
import NumericWidget from './NumericWidget';
import DateTimeWidget from './DateTimeWidget';
import CatalogWidget from './CatalogWidget';
import {useUser} from '../../lib/user';
import {getQuestionDisplayLabel} from '../../screens/FormBuilderScreen/shared';


/**
 * The question chart component is a multiplexer to each question chart type.
 */
function QuestionChart({sheetsById, question, answers, catalog, onHide, published, onPin, unPin, user, dashboardWidgetSet, templates, filters, sheetIds, allSheetsPinned, parentTemplateId}) {

  const history = useHistory();
  const currentUser = useUser();
  const [step, setStep] = useState(10);

  let QuestionChartType;

  // Determine which widget to display.
  switch(question.type) {
    case 'SCANNED_CODE':
    case 'TEXT':
      QuestionChartType = TextWidget;
      break;
    case 'IMAGE':
    case 'SIGNATURE':
      QuestionChartType = PhotoGalleryWidget;
      break;
    case 'BOOLEAN':
      QuestionChartType = BooleanWidget;
      break;
    case 'RADIO':
    case 'CHECKBOXES':
      QuestionChartType = QuestionOptionsWidget;
      break;
    case 'NUMERIC':
    case 'MEASURED_NUMERIC':
    case 'MULTI_NUMERIC':
      QuestionChartType = NumericWidget;
      break;
    case 'DATETIME':
      QuestionChartType = DateTimeWidget;
      break;
    case 'CATALOG_RADIO':
    case 'CATALOG_CHECKBOX':
      QuestionChartType = CatalogWidget;
      break;
    default:
      throw new Error(`Unknown question type: ${question.type}`);
  }

  if(answers.length < 1) {
    QuestionChartType = NoAnswersYet;
  }

  let options = [];
  
  let sheetString = "all";
  if(!allSheetsPinned && sheetIds !== undefined) {
    sheetString = sheetIds.join()
  }

  let linkWithData = { 
    pathname: `/sheet/${parentTemplateId}/${sheetString}`,
    state: {filter: filters}
  };

  if(published && !dashboardWidgetSet && (currentUser.role !== "USER")) {
    options.push({title: 'Hide', onClick: () => onHide({source: 'Question', widget: {...question}})})
  } 

  if(flags.isOn(currentUser, 'PINNED_WIDGETS_ENABLED') && (currentUser.role !== "USER")) {
    options.push({title: 'Pin', onClick: () => onPin({source: 'Question', widget: {...question}, step: step})})
  }

  if(dashboardWidgetSet) {
    options.push({title: 'Go to parent form', onClick: () =>history.push(linkWithData)})
  }

  return (
    <Widget id={question.id} title={getQuestionDisplayLabel(question)}>
      <QuestionChartType
        id={question.id}
        sheetsById={sheetsById}
        question={question}
        answers={answers}
        catalog={catalog}
        unPin={unPin}
        dashboardWidgetSet={dashboardWidgetSet}
        options= {options}
        user={user}
        step={step}
        setStep={setStep}
      />
    </Widget>
  );
}

export default React.memo(QuestionChart);
